import React from 'react';
import { StyleSheet, View } from 'react-native';
import HairLineDivider from 'shared/components/vxl/divider/HairlineDivider/HairLineDivider';
import StepperItem, {
  StepProps,
} from 'shared/components/vxl/ProgressIndicator/StepChecklist/base/Step/Step';
import { Tag, TagProps } from 'shared/components/vxl/Tag/Tag';
import BodyBaseBoldText from 'shared/components/vxl/typography/primary/body/BodyBaseBoldText';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import theme from 'shared/styles/theme';

export interface StepChecklistProps {
  stepperHeading: string;
  tagContent?: TagProps;
  subHeading?: string;
  stepperStates: StepProps[];
}

const StepChecklist = ({
  stepperHeading,
  tagContent,
  subHeading,
  stepperStates,
}: StepChecklistProps) => {
  return (
    <View style={styles.containerStepper}>
      <View>
        <View
          style={[
            styles.header,
            handleTextPosition(!!tagContent || !!subHeading, stepperHeading),
          ]}
        >
          {stepperHeading ? (
            <BodyBaseBoldText numberOfLines={1} style={styles.heading}>
              {stepperHeading}
            </BodyBaseBoldText>
          ) : null}
          {tagContent ? (
            <View>
              <Tag
                {...tagContent}
                iconKey={tagContent?.iconKey}
                text={tagContent?.text}
                type={tagContent?.type}
              />
            </View>
          ) : null}
          {subHeading ? (
            <BodyBaseText numberOfLines={0}>{subHeading}</BodyBaseText>
          ) : null}
        </View>

        {stepperStates?.map((step, index) => {
          const isLastItem = index === stepperStates?.length - 1;
          const isFirst = index === 0;
          const previousStep =
            index > 0 ? stepperStates[index - 1] : stepperStates[index];
          return (
            <View key={step?.id}>
              <View style={styles.stepContainer}>
                <StepperItem
                  step={step}
                  previousStep={previousStep}
                  isLastItem={isLastItem}
                  isFirst={isFirst}
                />
              </View>
              {!isLastItem ? (
                <View style={styles.divider}>
                  <HairLineDivider />
                </View>
              ) : null}
            </View>
          );
        })}
      </View>
    </View>
  );
};

const handleTextPosition = (tag: boolean, heading: string) => {
  if (tag && !heading) {
    return styles.rightAlign;
  } else if (!tag && heading) {
    return styles.leftAlign;
  }
};

const styles = StyleSheet.create({
  containerStepper: {
    backgroundColor: theme.color.background.primary,
    borderRadius: theme.spacing.xs,
    flexGrow: 1,
    padding: theme.spacing.m,
    paddingBottom: 0,
    paddingTop: 0,
  },
  divider: {
    paddingLeft: theme.spacing.xl,
    paddingRight: theme.spacing.s,
  },
  header: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.spacing.xs,
    justifyContent: 'space-between',
  },
  heading: {
    flexShrink: 1,
    paddingTop: theme.spacing.m,
  },
  leftAlign: {
    justifyContent: 'flex-start',
  },
  rightAlign: {
    justifyContent: 'flex-end',
  },
  stepContainer: {
    flexDirection: 'row',
    width: '100%',
  },
});

export default StepChecklist;
